const COMMON = {
	REDUX_ACTION: {
		LOGOUT: "LOGOUT",
	},
	REDUX_PRESIST_KEY: "root_hr_web_6a46285d-e323-48ae-8a84-e1bc036f0223",
	AUTH_TOKEN: "altecflex_hr_web_@99e53932-f4d8-46fc-9bba-757fd5e32783_auth_tk",
	REFRESH_TOKEN: "altecflex_hr_web_@273f71f5-0d2d-45cd-b93b-fee2c84aea7b_refresh_tk",
	ENDPOINT_PATH: {
		GENERAL: {
			LOGO: "general/logo",
			LIST: "general/lookup/detail",
			PROFILE: "general/profile/whoami",
			UPLOAD_AVATAR: "general/profile/avatar",
			COMPANY: "general/profile/company/detail",
			COMPANIES: "general/profile/company/list",
			CITIES: "general/public/address/city/page",
			STATES: "general/public/address/state/page",
			POSTCODE: "general/public/address/postcode/",
			UPLOAD_COMPANY_LOGO: "general/upload/logo",
			REFRESH_TOKEN: "authentication/public/token/refresh",
			MAINTENANCE: "service/config/config.json",
			SEND_OTP: "general/profile/change-password/email/otp-code",
			UPDATE_PASSWORD: "general/profile/change-password/update",
			SEND_RESET_PASSWORD_OTP: "general/reset-password/email/otp-code",
			VERIFY_RESET_PASSWORD_OTP: "general/reset-password/otp-verify",
			VERIFY_OTP: "general/profile/change-password/otp-verify",
			RESET_PASSWORD: "general/reset-password/reset",
		},
		NOTIFICATION: {
			LIST: "general/notification/list",
			UNREAD_COUNT: "general/notification/unread-count",
			MARK_AS_READ: "general/notification/mark-as-read/",
			MARK_ALL_AS_READ: "general/notification/mark-all-as-read",
		},
		APPOINTMENT: {
			APPOINTMENTS_CREATE: "general/appointment/insert-appointment",
			LIST: "general/appointment/appointment-search",
			EXPORT: "general/appointment/export",
			APPOINTMENTS_UPDATE: "general/appointment/update-appointment-status",
			CHECK_AVAILABILITY: "general/appointment/check-availability",
		},
		COURSE: {
			CREATE: "general/admin-course/create",
			UPDATE: "general/admin-course/update",
			LIST: "general/admin-course/page",
			GET_ALL_LIST: "general/admin-course/all-course-list",
			UPLOAD: "general/admin-course/upload/",
			DELETE: "general/admin-course/delete/",
			DELETE_FILES: "general/admin-course/delete-files",
		},
		ASSIGNMENT: {
			CREATE: "general/admin-assignment/create",
			UPLOAD_DOCUMENT: "general/admin-assignment/upload-cert/",
			UPDATE_STATUS: "general/admin-assignment/update-status/",
			LIST: "general/admin-assignment/page",
			ONGOING_LIST: "general/admin-assignment/ongoing/page",
			EXPORT: "general/admin-assignment/export",
		},
		REMINDER_TEMPLATE: {
			CREATE: "general/admin-reminder-template/create",
			UPDATE: "general/admin-reminder-template/update",
			LIST: "general/admin-reminder-template/page",
			OPTION: "general/admin-reminder-template/list",
			DELETE: "general/admin-reminder-template/delete/",
		},
		CERTIFICATE: {
			LIST: "general/admin-certificate/page",
		},
		AUTHENTICATE: {
			SIGN_IN: "authentication/public/token",
			USER: "general/profile/company/",
		},
		DASHBOARD: {
			ADMIN: "general/admin",
		},
		SETUP: {
			SUBMIT: "general/setup/submit",
			COMPANIES: "general/companies",
			DOCUMENTS: "general/insurance-doc",
			PURCHASER: "general/setup/purchaser",
			TOTAL_EMPLOYEE: "general/setup/draft/",
			UPLOAD: "general/insurance-doc/upload",
			INVITE: "general/setup/invite/employee",
			AGE_REQUIREMENT: "general/setup/age-req",
			EMPLOYEES: "general/setup/draft/employee",
			DELETE: "general/setup/draft/employee/delete",
			EMPLOYEE: "general/setup/draft/employee/detail",
			UPLOADED_DOCUMENT: "general/insurance-doc/uploaded",
			UPDATE_PURCHASER: "general/setup/purchaser/update",
			COVERAGES: "general/manage-coverage/page",
			UPDATE_COVERAGE: "general/manage-coverage/update-coverage",
			INSURANCE_PLANS_LIST: "general/manage-coverage/insurance-dropdown",
			UTILIZATION_INSURANCE: "general/manage-coverage/insurance-utilization",
		},
		ANNOUNCEMENTS: {
			CREATE: "announcement/create",
			DELETE: "announcement/delete/",
			UPLOAD: "announcement/upload/",
			UPDATE: "announcement/update",
			LIST: "announcement/posted/page",
			UPCOMING: "announcement/upcoming/page",
		},
		BENEFITS: {
			BENEFIT: "benefit/company-benefit-package/details/",
			LIST: "benefit/company-benefit-package/page",
			OPTION: "benefit/company-benefit-package/list",
			CREATE: "benefit/company-benefit-package/create",
			UPDATE: "benefit/company-benefit-package/update",
		},
		LEAVES: {
			CALENDAR: "general/calendar/",
			CANCEL: "general/admin-leave/cancel",
			REJECT: "general/leave-approval/reject",
			APPROVE: "general/leave-approval/approve",
			LIST: "general/admin-leave/employee-leave/page",
			LEAVE: "general/admin-leave/employee-leave/details/",
			SUMMARY: "general/admin-leave/employee-leave/summary/",
			REFRESH: "general/employee-leave-balance/refresh-balance/",
			UPCOMING: "general/admin-leave/employee-leave/upcoming/page",
			PENDING_APPROVAL_LIST: "general/admin-leave/my-approvals/page",
			EXPORT: "general/admin-leave/export",
		},
		HOLIDAY_CALENDAR: {
			LIST: "general/holiday-calendar/list",
			SEARCH: "general/holiday-calendar/search",
			REGIONS: "general/holiday-calendar/regions",
			YEAR: "general/holiday-calendar/year/",
			DETAIL: "general/holiday-calendar/",
			CREATE: "general/holiday-calendar/create",
			UPDATE: "general/holiday-calendar/update",
			DUPLICATE: "general/holiday-calendar/duplicate",
			DELETE: "general/holiday-calendar/delete/",
		},
		OVERTIME: {
			PENDING: "general/admin-overtime/pending",
			HISTORY: "general/admin-overtime/history",
			SEARCH: "general/admin-overtime/search",
			DETAILS: "general/admin-overtime/details/",
			APPROVE: "general/admin-overtime/approve",
			REJECT: "general/admin-overtime/reject",
			EDIT: "general/admin-overtime/edit",
		},
		POSITIONS: {
			LIST: "general/position/page",
			OPTION: "general/position/list",
			UPDATE: "general/position/update",
			CREATE: "general/position/create",
		},
		SCHEDULER: {
			LIST: "general/scheduler/jobs",
			UPDATE: "general/scheduler/jobs/",
		},
		EMAIL_TEMPLATE: {
			BANNER_LOGO: "general/email/banner-logo",
			UPLOAD_BANNER_LOGO: "general/upload/email-banner-logo",
			LIST: "general/email/template",
			DETAIL: "general/email/template/",
			UPDATE: "general/email/template/",
			RESET: "general/email/template/",
			PREVIEW: "general/email/template/",
		},
		EMPLOYEE: {
			LIST: "employee/admin/search",
			ORGANISATION: "employee/user-company",
			CREATE: "employee/invite-employee/create",
			INSURANCE_PLANS_LIST: "employee/eb-order/items",
			DIRECTORY_LIST: "employee/admin/directory/page",
			AGE_REQUIREMENT: "employee/invite-employee/age-req",
			EMPLOYEE_INFO: "employee/admin/detail/employee-info",
			PERSONAL_INFO: "employee/admin/detail/personal-info",
			DETAIL_EMAIL: "employee/admin/detail/email",
			EMPLOYEE_DOCUMENT: "employee/admin/detail/employee-document",
			UPDATE_PERSONAL_INFO: "employee/admin/update/personal-info",
			UPDATE_EMPLOYEE_INFO: "employee/admin/update/employee-info",
			UPLOAD_EMPLOYEE_DOCUMENT: "employee/admin/upload/employee-document",
			DELETE_EMPLOYEE_DOCUMENT: "employee/admin/delete/employee-document",
			REJECT_INTERN: "employee/confirmation/intern/reject",
			APPROVE_PROBATION: "employee/confirmation/probation/approve",
			REJECT_PROBATION: "employee/confirmation/probation/reject",
			REPORTING_MANAGER_OPTION: "employee/admin/reporting-manager/list",
			REINVITE_TERMINATED_USER: "employee/admin/resend-invite-terminated",
			EXPORT_EMPLOYEE_AS_EXCEL: "employee/admin/generateExcel",
		},
		ADMIN: {
			LIST: "general/employee/admin/page",
			EMPLOYEE_LIST: "general/employee/staff/list",
			ALL_EMPLOYEE_LIST: "general/employee/staff/all-employee-list",
			REMOVE_ADMIN: "general/management-role/remove/admin",
			ASSIGN_ADMIN: "general/management-role/assign/admin",
		},
		AMENDMENT_REQUEST: {
			SUBMIT: "employee/amendment/submit",
			UPLOAD: "employee/amendment/upload/",
			LIST: "employee/amendment/page",
			DETAILS: "employee/amendment/details/",
		},
		CLAIMS: {
			LIST: "claim/admin-claim/page/",
			REJECT: "claim/admin-claim/reject",
			CANCEL: "claim/admin-claim/cancel",
			APPROVE: "claim/admin-claim/approve",
			CLAIM: "claim/admin-claim/details/",
			SUMMARY: "claim/admin-claim/summary/",
			REFRESH: "claim/employee-claim-balance/refresh/",
			PENDING_APPROVAL_LIST: "claim/admin-claim/my-approvals/page",
			LIST_OF_EMPLOYEE_CLAIMS: "claim/admin-claim/list-employee-claims",
			EXPORT: "claim/admin-claim/export",
		},
		ORDERS: {
			LIST: "general/order/page",
			ORDER: "general/order/details/",
			DELETE_ADDITIONAL_DOCUMENT: "general/insurance-doc/delete",
			ADDITIONAL_DOCUMENTS: "general/insurance-doc/uploaded/additional",
			SUBMIT_ADDITIONAL_DOCUMENTS: "general/insurance-doc/submit/additional",
		},
		POLICIES: {
			LIST: "policy/eb-policy/page",
			POLICY: "policy/eb-policy/details",
			DOCUMENTS: "policy/eb-policy/documents",
			DOWNLOAD_DOCUMENTS: "policy/eb-policy/file/download",
			INSURER: "policy/eb-policy/insured",
			DEBIT_NOTE: "policy/eb-invoice/debit/all",
			CREDIT_NOTE: "policy/eb-invoice/credit/all",
			UNPAID_DEBIT_NOTE: "policy/eb-invoice/debit/unpaid",
			UNCLAIMED_CREDIT_AMOUNT: "policy/eb-invoice/credit/unclaimed-amount",
			UNPAID_DEBIT_AMOUNT: "policy/eb-invoice/debit/unpaid-amount",
			REFUND_CREDIT: "policy/eb-invoice/credit/request-refund",
			DEBIT_NOTE_INVOICE_PAYMENT: "policy/eb-invoice-payment/pay",
			INVOICE_FILES: "policy/eb-invoice/files/",
			DOWNLOAD_INVOICES: "policy/eb-invoice/file/download",
			CREDIT_PAYMENT_HISTORY: "policy/payment-history/credit/",
			CREDIT_PAYMENT_HISTORY_RECEIPT: "policy/payment-history/credit/files/",
			DEBIT_PAYMENT_HISTORY: "policy/payment-history/debit/",
			DEBIT_PAYMENT_HISTORY_RECEIPT: "policy/payment-history/debit/files/",
			CREDIT_DOWNLOAD_RECEIPT: "policy/payment-history/credit/files/download",
			DEBIT_DOWNLOAD_RECEIPT: "policy/payment-history/debit/files/download",
			REJECT_POLICY_RENEWAL: "policy/eb-policy-renewal/reject",
			UPLOAD_POLICY_RENEWAL: "policy/eb-policy-renewal/upload-file/",
			RENEWAL_PAYMENT: "policy/eb-policy-renewal-payment/pay",
			QUOTATIONS: "policy/eb-policy-renewal/quotation/list/",
			DOWNLOAD_QUOTATIONS: "policy/eb-policy-renewal/quotation/download",
			REVISE_QUOTATION_EMPLOYEES: "policy/eb-policy-renewal/revise-quotation/employee/list",
			REVISE_QUOTATION: "policy/eb-policy-renewal/revise-quotation/request",
		},
		COVERAGES: {
			CLAIMS: "product/eb-claim/page",
			CLAIM: "product/eb-claim/details/",
			LIST: "policy/manage-coverage/page",
			CLAIMANTS: "product/eb-claim/insured/list/",
			INSURANCE_PLANS_LIST: "policy/manage-coverage/insurance-dropdown",
			UPDATE_INSURER_COVERAGE: "policy/manage-coverage/update-coverage",
			UTILIZATION_INSURANCE: "policy/manage-coverage/insurance-utilization",
			POLICIES: "product/eb-claim/policy-no/list",
			CLAIM_DOCUMENTS: "product/eb-claim/doc/list/",
			POLICY_CLAIM_TYPE: "product/eb-claim/type/list/",
			ALL_CLAIM_TYPE: "product/eb-claim/type/all/list",
			DOWNLOAD_CLAIM_DOCUMENTS: "product/eb-claim/doc/list/download",
			SUBMIT_CLAIM: "product/eb-claim/submit",
			UPLOAD_CLAIM: "product/eb-claim/upload-doc/",
			UPLOAD_ADDITIONAL_CLAIM_DOCUMENT: "product/eb-claim/additional/upload-doc/",
			COMPANIES: "policy/user-company",
		},
	},
	REGEX: {
		SYMBOL: /(\W|_)/,
		NUMERIC: /(?=.*\d)/,
		ALPHABETIC: /^[A-Za-z/ ]+$/,
		LOWERCASE: /(?=.*[a-z])/,
		UPPERCASE: /(?=.*[A-Z])/,
		EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	},
	MASKING: {
		NRIC: "******-**-****",
	},
	RELATIONSHIP: {
		SPOUSE: "SPOUSE",
		MARRIED: "MARRIED",
	},
	IDENTIFICATION_TYPE: {
		NRIC: "NRIC",
		PASSPORT: "PASSPORT",
	},
	NATIONALITY: {
		MALAYSIAN: "MALAYSIAN",
		FOREIGNER: "FOREIGNER",
	},
	DROPDOWNS: {
		OVERTIME_STATUS: [
			{ label: "Approved", value: "APPROVED" },
			{ label: "Rejected", value: "REJECTED" },
			{ label: "Cancelled", value: "CANCELLED" },
		],
		OVERTIME_PENDING_STATUS: [
			{ label: "Pending Manager Approval", value: "PENDING_MANAGER" },
			{ label: "Pending Admin Approval", value: "PENDING_ADMIN" },
		],
		OVERTIME_REJECT_REASON: [
			{ label: "Duplicated OT", value: "DUPLICATED_OT" },
			{ label: "Not covered by HR Policy", value: "NOT_COVERED_BY_HR_POLICY" },
			{ label: "Late Submission", value: "LATE_SUBMISSION" },
			{ label: "Others", value: "OTHERS" },
		],
		EXAM_STATUS: [
			{ label: "Pass", value: "COMPLETED" },
			{ label: "Fail", value: "FAILED" },
		],
		APPOINTMENT: [
			{ label: "Upcoming", value: "UPCOMING" },
			{ label: "Acknowledged", value: "ACKNOWLEDGED" },
			{ label: "Completed", value: "COMPLETED" },
			{ label: "Cancelled", value: "CANCELLED" },
			{ label: "Overdue", value: "OVERDUE" },
		],
		ONGOING_ASSIGNMENT: [
			{ label: "Assigned", value: "ASSIGNED" },
			{ label: "Ready", value: "READY" },
		],
		ASSIGNMENT_HISTORY: [
			{ label: "Completed", value: "COMPLETED" },
			{ label: "Failed", value: "FAILED" },
			{ label: "Overdue", value: "OVERDUE" },
			{ label: "Assigned", value: "ASSIGNED" },
			{ label: "Ready", value: "READY" },
		],
		CERTIFICATE: [
			{ label: "Active", value: "ACTIVE" },
			{ label: "Expired", value: "EXPIRED" },
		],
		GENDER: [
			{ label: "Male", value: "MALE" },
			{ label: "Female", value: "FEMALE" },
		],
		DAYS_CALCULATION: [
			{ label: "Calendar Days", value: "CALENDAR_DAYS" },
			{ label: "Working Days", value: "WORKING_DAYS" },
			{ label: "Per Occasion", value: "PER_OCCASION" },
		],
		LEAVES_STATUS: [
			{ label: "Working", value: "WORKING" },
			{ label: "On Leave", value: "ON_LEAVE" },
		],
		LEAVES_HISTORY_STATUS: [
			{ label: "Approved", value: "APPROVED" },
			{ label: "Cancelled", value: "CANCELLED" },
			{ label: "Rejected", value: "REJECTED" },
		],
		LEAVES_TYPE: [
			{ label: "Annual Leave", value: "ANNUAL_LEAVE" },
			{ label: "Sick Leave", value: "SICK_LEAVE" },
			{ label: "Hospitalisation Leave", value: "HOSPITALISATION_LEAVE" },
			{ label: "Maternity Leave", value: "MATERNITY_LEAVE" },
			{ label: "Paternity Leave", value: "PATERNITY_LEAVE" },
			{ label: "Carry Forward Leave", value: "CARRY_FORWARD_LEAVE" },
			{ label: "Marriage Leave", value: "MARRIAGE_LEAVE" },
			{ label: "Emergency Leave", value: "EMERGENCY_LEAVE" },
			{ label: "Unpaid Leave", value: "UNPAID_LEAVE" },
			{ label: "Compassionate Leave", value: "COMPASSIONATE_LEAVE" },
			{ label: "Replacement Leave", value: "REPLACEMENT_LEAVE" },
		],
		INSURANCE_CLAIM_STATUS: [
			{ label: "Deferment", value: "DEFERMENT" },
			{ label: "Approved", value: "APPROVED" },
			{ label: "Rejected", value: "REJECTED" },
		],
		INSURANCE_SEARCH_CLAIM_STATUS: [
			{ label: "Cancelled", value: "CANCELLED" },
			{ label: "Approved", value: "APPROVED" },
			{ label: "Pending", value: "PENDING" },
			{ label: "Rejected", value: "REJECTED" },
		],
		AMENDMENT_REQUEST_STATUS: [
			{ label: "Pending", value: "PENDING" },
			{ label: "Submitted", value: "SUBMITTED" },
			{ label: "Approved", value: "APPROVED" },
			{ label: "Rejected", value: "REJECTED" },
		],
		REJECT_POLICY_REASON: [
			{ label: "Expensive Premium", value: "Expensive Premium" },
			{ label: "Wish to switch to another provider", value: "Wish to switch to another provider" },
			{ label: "Wish to enhance coverage plan", value: "Wish to enhance coverage plan" },
			{ label: "Other reason", value: "Other reason" },
		],
		PLANS: [
			{ label: "Premier", value: "PREMIER" },
			{ label: "Regular Plus", value: "REGULAR_PLUS" },
			{ label: "Regular", value: "REGULAR" },
			{ label: "Not covered", value: "NOT_COVERED" },
		],
	},
	BENEFITS: {
		DAYS: {
			CALENDAR_DAYS: "CALENDAR_DAYS",
			WORKING_DAYS: "WORKING_DAYS",
			PER_OCCASION: "PER_OCCASION",
		},
		LEAVES: {
			ANNUAL_LEAVE: "ANNUAL_LEAVE",
			SICK_LEAVE: "SICK_LEAVE",
			PATERNITY_LEAVE: "PATERNITY_LEAVE",
			MATERNITY_LEAVE: "MATERNITY_LEAVE",
			HOSPITALISATION_LEAVE: "HOSPITALISATION_LEAVE",
			CARRY_FORWARD_LEAVE: "CARRY_FORWARD_LEAVE",
			REPLACEMENT_LEAVE: "REPLACEMENT_LEAVE",
		},
		LEAVE_LABELS: {
			REPLACEMENT_LEAVE: "Replacement Leave",
		},
		LEAVE_SHORT_FORMS: {
			ANNUAL_LEAVE: "AL",
			SICK_LEAVE: "SL",
			PATERNITY_LEAVE: "PL",
			MATERNITY_LEAVE: "ML",
			HOSPITALISATION_LEAVE: "HL",
			CARRY_FORWARD_LEAVE: "CFL",
			COMPASSIONATE_LEAVE: "CL",
			REPLACEMENT_LEAVE: "RL",
			MARRIAGE_LEAVE: "MRL",
			EMERGENCY_LEAVE: "EL",
			UNPAID_LEAVE: "UPL",
		},
		CLAIMS: {
			MEDICAL_CLAIM: "MEDICAL_CLAIM",
			OPTICAL_DENTAL_CLAIM: "OPTICAL_DENTAL_CLAIM",
			OTHER_CLAIM: "OTHER_CLAIM",
		},
	},
	EMPLOYEE: {
		SETUP: {
			SETUP: "SETUP",
			COMPLETED: "COMPLETED",
			INCOMPLETE: "INCOMPLETE",
			ORDER_COMPLETED: "ORDER_COMPLETED",
		},
		CONTRACT_TYPE: {
			FULL_TIME_EMPLOYEE: "FULL_TIME_EMPLOYEE",
		},
	},
	MAX_FILE_SIZES: {
		MB_5: 5000000,
		MB_10: 10000000,
		MB_15: 15000000,
		MB_30: 30000000,
		MB_50: 50000000,
		MB_60: 60000000,
	},
	APP_STATUS: {
		NEW: "new",
	},
	STATUS_ID: {
		ACTIVE: "ACTIVE",
		INACTIVE: "INACTIVE",
		DELETED: "DELETED",
		DISABLED: "DISABLED",
		EXPIRED: "EXPIRED",
		PENDING: "PENDING",
		REJECTED: "REJECTED",
		SUCCEEDED: "SUCCEEDED",
		CANCELLED: "CANCELLED",
		DECLINED: "DECLINED",
		ACCEPTED: "ACCEPTED",
		SUBMITTED: "SUBMITTED",
		FAILED: "FAILED",
		READ: "READ",
		NOT_READ: "NOT_READ",
		WORKING: "WORKING",
		ON_LEAVE: "ON_LEAVE",
		APPROVED: "APPROVED",
		PROBATION: "PROBATION",
		INTERN: "INTERN",
		COMPLETED: "COMPLETED",
		PERMANENT: "PERMANENT",
		TERMINATION: "TERMINATION",
		RESIGNED: "RESIGNED",
		DISMISSAL: "DISMISSAL",
		DECEASED: "DECEASED",
		END_OF_CONTRACT: "END_OF_CONTRACT",
		PENDING_APPROVAL: "PENDING_APPROVAL",
		PENDING_MANAGER: "PENDING_MANAGER",
		PENDING_ADMIN: "PENDING_ADMIN",
		INVITATION_PENDING: "INVITATION_PENDING",
		CONVERSATION_ENDED: "CONVERSATION_ENDED",
		FULL_TIME_EMPLOYEE: "FULL_TIME_EMPLOYEE",
		FORCE_CHANGE_PASSWORD: "FORCE_CHANGE_PASSWORD",
		PENDING_COMPANY_SETUP: "PENDING_COMPANY_SETUP",
		ORDER_PROCESSING: "ORDER_PROCESSING",
		DEFERMENT: "DEFERMENT",
		ORDER_REJECTED: "ORDER_REJECTED",
		ORDER_COMPLETED: "ORDER_COMPLETED",
		PAYMENT_FAILED: "PAYMENT_FAILED",
		PAYMENT_EXPIRED: "PAYMENT_EXPIRED",
		ORDER_CANCELLED: "ORDER_CANCELLED",
		PENDING_RELEASE_PAYMENT: "PENDING_RELEASE_PAYMENT",
		PENDING_POLICY_IN_FORCE: "PENDING_POLICY_IN_FORCE",
		CANCEL: "CANCEL",
		MATURED: "MATURED",
		IN_FORCE: "IN_FORCE",
		WITHDRAWN: "WITHDRAWN",
		SUSPENDED: "SUSPENDED",
		SURRENDER: "SURRENDER",
		TERMINATED: "TERMINATED",
		PAYER_WAIVER: "PAYER_WAIVER",
		PREMIUM_HOLIDAY: "PREMIUM_HOLIDAY",
		TERMINATED_DEATH: "TERMINATED_DEATH",
		TERMINATED_MANUAL: "TERMINATED_MANUAL",
		CONDITIONAL_APPROVED: "CONDITIONAL_APPROVED",
		PENDING_ADDITIONAL_DOCS: "PENDING_ADDITIONAL_DOCS",
		PROCESSING: "PROCESSING",
		SUCCESSFUL: "SUCCESSFUL",
		REFUNDED: "REFUNDED",
		UNCLAIMED: "UNCLAIMED",
		REFUND_IN_PROGRESS: "REFUND_IN_PROGRESS",
		UNPAID: "UNPAID",
		PAID: "PAID",
		PENDING_PAYMENT: "PENDING_PAYMENT",
		PENDING_IN_FORCE: "PENDING_IN_FORCE",
		PENDING_POLICY_NO: "PENDING_POLICY_NO",
		PAYMENT_IN_PROGRESS: "PAYMENT_IN_PROGRESS",
		REQUEST_REVISED_QUOTATION: "REQUEST_REVISED_QUOTATION",
		PENDING_REVISED_QUOTATION: "PENDING_REVISED_QUOTATION",
		UPCOMING: "UPCOMING",
		ACKNOWLEDGED: "ACKNOWLEDGED",
		OVERDUE: "OVERDUE",
		ASSIGNED: "ASSIGNED",
		READY: "READY",
		ENABLED: "ENABLED",
	},
	STATUS_CODE: {
		USER_BLOCKED: "MC_000018",
		INVALID_TOKEN: "MC_000016",
		TOKEN_EXPIRED: "MC_000011",
		TOKEN_EXPIRED_2: "HRC_000011",
		REFRESH_TOKEN_EXPIRED: "MC_000017",
		MAXIMUM_PASSWORD_ATTEMPTS: "MC_UAA_00010",
		
		// overtime compensation
		OVERTIME_NOT_FOUND: "HR_OVERTIME_000001",
		OVERTIME_INVALID_TIME: "HR_OVERTIME_000002",
		OVERTIME_DUPLICATED: "HR_OVERTIME_000003",
		OVERTIME_NO_REPORTING_MANAGER: "HR_OVERTIME_000004",
		OVERTIME_INVALID_ALLOWANCE: "HR_OVERTIME_000005",
		OVERTIME_INSUFFICIENT_REPLACEMENT_LEAVE: "HR_OVERTIME_000006",
		OVERTIME_NO_REPLACEMENT_LEAVE: "HR_OVERTIME_000007",
		OVERTIME_INVALID_SEARCH_TYPE: "HR_OVERTIME_000008",
		RECORD_NOT_FOUND: "HR_LEAVE_000003",
		FILE_LIMIT_EXCEEDED: "HR_LEAVE_000006",
		USER_UNAUTHORIZED: "HR_LEAVE_000007",
		REJECT_REASON_MISSING: "HR_LEAVE_000010",
		OPERATION_NOT_PERMITTED: "HR_LEAVE_000011",
	},
	OVERTIME: {
		REJECT_REASON: {
			OTHERS: "OTHERS",
		},
		SEARCH_TYPE: {
			PENDING: "PENDING",
			HISTORY: "HISTORY",
		},
	},
	INSURANCE: {
		PLANS: {
			PREMIER: "PREMIER",
			REGULAR_PLUS: "REGULAR_PLUS",
			REGULAR: "REGULAR",
			NOT_COVERED: "NOT_COVERED",
		},
		PRODUCT_EB_CODE: {
			GHS: "GHS",
			GTL: "GTL",
			GO: "GO",
		},
		COVERAGES: {
			ROOM_AND_BOARD: "ROOM_AND_BOARD",
		},
		CLAIMS: {
			DOCUMENTS: {
				ADDITIONAL_REQUIRED_DOC: "ADDITIONAL_REQUIRED_DOC",
				BASIC_REQUIRED_DOC: "BASIC_REQUIRED_DOC",
			},
		},
	},
	COVERAGES: {
		PAYMENT_TYPE: {
			DEBIT_NOTE: "DEBIT_NOTE",
			CREDIT_NOTE: "CREDIT_NOTE",
		},
	},
	TABLE_REQUEST_STATUS: {
		INSTANCE: "INSTANCE",
	},
};

export default COMMON;
